"use strict";

angular.module("core")
.component("invoicePaymentInline", {
    templateUrl: require("./invoice-payment-inline.component.html"),
    bindings: {
        invoices: "<"
    },
    controller: function($scope, POPOVER_POPUP_DELAY, POPOVER_MIN_ELEMENT) {
        $scope.POPOVER_POPUP_DELAY = POPOVER_POPUP_DELAY;
        $scope.POPOVER_MIN_ELEMENT = POPOVER_MIN_ELEMENT;
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-payment-inline/invoice-payment-inline.component.js
// module id = 614
// module chunks = 0